/**
 * @file Builds the report definition the create form writes from its values.
 * Consumer: `AnalyticsReportForm`, which hands the result to
 * `createAnalyticsReport` for the service's own parser to validate. The name
 * is trimmed, every query takes no parameters beyond the definition's period,
 * and `nextRunAt` is `now`, so the first run comes at the next cycle.
 */
import type { AnalyticsReportDefinition } from '#types';

import type { AnalyticsReportFormValues } from './analyticsReportsTab.types';

export const analyticsReportDefinition = (
  values: AnalyticsReportFormValues,
  now: Date,
): AnalyticsReportDefinition => ({
  name: values.name.trim(),
  queries: values.queries.map((query) => ({ query, parameters: {} })),
  level: values.level,
  period: values.period,
  cadence: { every: values.every, hour: values.hour },
  recipientUids: values.recipientUids,
  nextRunAt: now.toISOString(),
});
